<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import moment from "moment";

export default {
	page: {
		title: 'Финансы',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: 'Финансовые операции',
            items: [],
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            type: null,
            isCompany: false,
            sortBy: 'created_at',
            sortDesc: true,
            fields: [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'created_at', label: 'Дата', sortable: true },                
                { key: 'sum', label: 'Сумма', sortable: true },
                { key: 'account_number', label: 'Аккаунт', sortable: true },                
                { key: 'comments', label: 'Комментарий', sortable: true },
                { key: 'status', label: 'Статус'},
                { key: 'action', label: ''}
            ],

            dateConfig: {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd.m.Y',
            },

            tableLoading: true,
            watch: false,

            date_start: moment().subtract('days', 1).format('DD.MM.YYYY'),
            date_end: moment().format('DD.MM.YYYY'),
            selectedDate: [moment().subtract('days', 1).format('DD.MM.YYYY'), moment().format('DD.MM.YYYY')],
		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['finance/GET_FINANCE_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['finance/GET_FINANCE_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {

        this.type = this.$route.params.type ? this.$route.params.type : null;

        if(this.session_user_item && this.session_user_item.role !== 'administrator'){

            if (this.session_user_item.iscompany === 'true'){
                this.isCompany = true;
            } else {
                this.fields = [
                    { key: 'select',   label: '', row:{'rowSelected':false}},
                    { key: 'created_at', label: 'Дата', sortable: true },
                    { key: 'sum', label: 'Сумма', sortable: true },
                    { key: 'status', label: 'Статус', sortable: true },
                    { key: 'comments', label: 'Комментарий', sortable: true },
                ]
            }

            if(this.type === 'payin') {
                this.title = 'История платежей';
                this.fields = [
                    { key: 'select',   label: '', row:{'rowSelected':false}},
                    { key: 'created_at', label: 'Дата', sortable: true },
                    { key: 'sum', label: 'Сумма', sortable: true },
                    { key: 'account_number', label: 'Аккаунт', sortable: true },
                    { key: 'comments', label: 'Комментарий', sortable: true },
                    { key: 'pay_method', label: 'Способ пополнения', sortable: true },
                    { key: 'status', label: 'Статус'},
                    { key: 'action', label: ''}
                ]            
            }
            if(this.type === 'payout') {
                this.title = 'Расходные операции';
            }            

        }	

        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            if(this.type === 'payin') {
                this.title = 'История платежей';
                this.fields = [
                    { key: 'select',   label: '', row:{'rowSelected':false}},
                    { key: 'id', label: 'ID', sortable: true },
                    { key: 'created_at', label: 'Дата', sortable: true },
                    { key: 'sum', label: 'Сумма', sortable: true },
                    { key: 'account_number', label: 'Аккаунт', sortable: true },
                    { key: 'user_data', label: 'Пользователь', sortable: false },
                    { key: 'comments', label: 'Комментарий', sortable: true },
                    { key: 'pay_method', label: 'Способ пополнения', sortable: true },
                    { key: 'status', label: 'Статус'},
                    { key: 'action', label: ''}
                ]            
            }
            if(this.type === 'payout') {
                this.title = 'Расходные операции';
                this.fields = [
                    { key: 'select',   label: '', row:{'rowSelected':false}},
                    { key: 'created_at', label: 'Дата', sortable: true },
                    { key: 'sum', label: 'Сумма', sortable: true },
                    { key: 'account_number', label: 'Аккаунт', sortable: true },
                    { key: 'user_data', label: 'Пользователь', sortable: false },
                    { key: 'comments', label: 'Комментарий', sortable: true },
                    { key: 'status', label: 'Статус'},
                    { key: 'action', label: ''}
                ]                
            }   
        } 

        this.date_start = this.selectedDate[0];
        this.date_end   = this.selectedDate[1];

        await this.getData();

    },

    methods: {

        async downloadReport(){

            let type = this.$route.params.type ? this.$route.params.type : null;
            let title = 'Финансовые операции';

            if(type === 'payin') {
                title = 'История платежей';
            }
            if(type === 'payout') {
                title = 'Расходные операции';
            }

            let url = "https://api.client.za-bota.com/report?" +
                'user_id=' + this.session_item.user.id +
                '&date_start=' + this.date_start +
                '&date_end=' + this.date_end +
                '&token=' + this.session_item.token +
                '&report_type=finance' +
                '&transactions_type=' + type +
                '&role=' + this.session_user_item.role +
                '&iscompany=' + this.session_user_item.iscompany +
                '&title=' + title + ': ' + this.date_start + ' -  ' + this.date_end;

            window.location.href = url;
        },

        async onChangePeriod(item){
            if(item[0] && item[1]){
                this.date_start = moment(item[0]).format('DD.MM.YYYY')
                this.date_end   = moment(item[1]).format('DD.MM.YYYY')
                await this.getData();
            }
        },

        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            let data_send = {
                'type'       : this.type,
                'limit'      : this.perPage,
                'page'       : this.currentPage,
                'sortBy'     : this.sortBy,
                'date_start' : this.date_start,
                'date_end'   : this.date_end,
                'sortDesc'   : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'     : this.filter,
                'filterOn'   : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('finance/FETCH_FINANCE_LIST', data_send);
            this.watch = true;
        }
    }
}

</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0">{{ title }}</h4>
            </div>

            <div class="col-sm-8 col-xl-6">
                <!-- <a href="#" @click="downloadReport()" class="btn btn-outline-primary" right style="margin-left: 5px; margin-right: 15px">
                    <i class="uil uil-export "></i>Сохранить
                </a> -->
                <div class="btn-group" style="float: right">
                    <b-button to="/account/payments/create" variant="primary" class="btn" right>
                        <i class="uil uil-bill " style="margin-right: 5px"></i>Пополнить счет
                    </b-button>
                </div>                
            </div>

        </div>
        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-3 col-md-3">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-9 col-md-9">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <div class="form-group mb-sm-0">
                                <label class="d-inline-flex align-items-center">
                                    Период: 
                                    <flat-pickr
                                        v-model="selectedDate"
                                        class="form-control ml-2"
                                        :config="dateConfig"
                                        @on-change="onChangePeriod"
                                        name="date"
                                    ></flat-pickr>
                                </label>
                                <label class="ml-3 d-inline-flex align-items-center">
                                    Поиск: 
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        @change="onFiltered()"
                                        placeholder="Введите текст..."
                                        class="form-control form-control-md ml-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- End search -->
                </div>

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class="tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                            ></b-table>
                        </div>
                        
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>